import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

import Header from './Header';
import logo from './images/icons/logo.JPG'; // Import your image here

const ModalViewHouses = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  let userCompanyID = localStorage.getItem('companyID')
  if(userCompanyID === 'Admin'){
    userCompanyID = 1;
  }
  userCompanyID = JSON.parse(userCompanyID)

  let userID = localStorage.getItem('userID')
  if(userID === 'Admin'){
    userID = 1;
  }
  userID = JSON.parse(userID)

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-ZM', { style: 'currency', currency: 'ZMW' }).format(amount);
  };

  const formatCurrencyTable = (amount) => {
    // Convert amount to a number if it's not already
    const number = typeof amount === 'number' ? amount : parseFloat(amount);
    return new Intl.NumberFormat('en-ZM', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number);
  };

  const [housesData, setHousesData] = useState([]);
  const [searchValueHouses, setSearchValueHouses] = useState('');
  const [entriesValueHouses, setEntriesValueHouses] = useState(5);
  const tableRef = useRef(null);

  useEffect(() => {
    fetchDataForTableHouses();
  }, [entriesValueHouses]);

  const fetchDataForTableHouses = async () => {
    const formData = new FormData();
    formData.append("apiType", 'viewHouses');
    formData.append('userCompanyID', userCompanyID);

    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      setHousesData(response.data);

      setTimeout(() => {
        const table = $('#tableViewHouses').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(5, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            $(api.column(5).footer()).html(formatCurrency(pageTotal.toFixed(2)));

            const overallTotal = api
              .column(5)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            $('#totalOverallHouses').html(formatCurrency(overallTotal.toFixed(2)));
          },
          retrieve: true,
          pageLength: entriesValueHouses,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setSearchValueHouses(api.search());
            setEntriesValueHouses(api.page.len());

            api.on('search.dt', function () {
              setSearchValueHouses(api.search());
            });

            api.on('length.dt', function () {
                setEntriesValueHouses(api.page.len());
            });
          }
        });
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };

  const handleExportPDF = () => {
    const doc = new jsPDF('landscape');
    const tableRows = [];
    const filteredData = housesData.filter(house =>
      Object.values(house).some(value =>
        value.toString().toLowerCase().includes(searchValueHouses.toLowerCase())
      )
    );

    let rentalPrice = 0.0;
    let rentalsTotalAmountPaid = 0.0;
  
    filteredData.forEach((house, index) => {
        rentalPrice += parseFloat(house.rentalPrice) || 0;
        rentalsTotalAmountPaid += parseFloat(house.rentalsTotalAmountPaid) || 0;

      tableRows.push([
        index + 1,
        house.businessLocationName,
        house.block,
        house.houseNumber,
        formatCurrencyTable(house.rentalPrice),
        formatCurrencyTable(house.rentalsTotalAmountPaid),
        house.rentalsFrequency
      ]);
    });

   doc.autoTable({
        head: [['SN', 'Location', 'Block', 'House #', 'Rentals', 'Total Amount Paid', 'Rentals Frequency']],
        body: tableRows,
        //foot: tableFootTemplate,
        didDrawPage: (data) => {
          // Add page number
          const pageCount = doc.internal.getNumberOfPages();
          const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
          const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    
          doc.setFontSize(10);
          doc.text(`Page ${data.pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 10);
    
          // Check if it's the last page and add the footer figures
          if (data.pageNumber === pageCount) {
            const finalY = pageHeight - 20; // Position footer just above the bottom margin
    
            // Draw the footer figures manually on the last page
            doc.setFontSize(12);
            const xPositions = {
                rentalPrice: 15, // Adjust these values according to your table layout
                rentalsTotalAmountPaid: 200
            };
    
            doc.text(`Total Rental Prices: ${formatCurrency(rentalPrice.toFixed(2))}`, xPositions.rentalPrice, finalY);
            doc.text(`Total Rentals Received: ${formatCurrency(rentalsTotalAmountPaid.toFixed(2))}`, xPositions.rentalsTotalAmountPaid, finalY);
          }
        },
        margin: { bottom: 30 },
      });
    

    doc.save('houses.pdf');
  };

  return (
    <>
      <Header />
      <main className="bg-white">
        <hr />
        <div className="container-fluid mt-5" style={{ overflowX: 'auto' }}>
          <button onClick={handleExportPDF} className="btn btn-primary mb-3">PDF</button>
          <table id="tableViewHouses" className="table table-striped table-bordered table-hover table-sm">
            <thead className="ocean blue-gradient white-text">
              <tr>
                <th className="font-weight-bold"><strong>SN</strong></th>
                <th className="font-weight-bold"><strong>Location</strong></th>
                <th className="font-weight-bold"><strong>Block</strong></th>
                <th className="font-weight-bold"><strong>House #</strong></th>
                <th className="font-weight-bold"><strong>Rentals</strong></th>
                <th className="font-weight-bold"><strong>Total Amount Paid</strong></th>
                <th className="font-weight-bold"><strong>Rentals Frequency</strong></th>
              </tr>
            </thead>
            <tbody>
              {housesData.map((house, index) => (
                <tr key={house.rentalsID} id={house.rentalsID}>
                  <td>{index + 1}</td>
                  <td>{house.businessLocationName}</td>
                  <td>{house.block}</td>
                  <td>{house.houseNumber}</td>
                  <td>{house.rentalPrice}</td>
                  <td>{house.rentalsTotalAmountPaid}</td>
                  <td>{house.rentalsFrequency}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="form-header text-center black-text">
              <tr>
                <th></th>
                <th>Total</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </main>
    </>
  );
};

export default ModalViewHouses;
